export default __webpack_public_path__ + "static/imda2018top92-ebc689b2972521bf68be4f9050344115.jpg";